import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import Autocomplete from 'react-autocomplete'
import moment from 'moment'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import momenttz from '../../component/helpers/momenttz'
import { tableExportOptions } from '../../component/helpers/table'
import { getDevicesList } from '../../action/DeviceActions'
import EventClipsDateRange from '../../component/smart/menuComponentsContainer/EventClipsDateRange'
import { searchIcon } from '../../component/helpers/iconHelpers'
import CustomButton from '../../component/CustomButton'
import { getDriverTripsPhotos } from "../../action/CompaniesActions";

const DebugSnapshots = (props) => {
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'driversPage.debugSnapshots' });
	const { user, company, toggleLoader } = props;

	const [initialData, setInitialData] = useState([]);
	const [autoValue, setAutoValue] = useState('');
	const [selectedRow, setSelectedRow] = useState(null);
	const [devices, setDevices] = useState([]);
	const [trips, setTrips] = useState([]);
	const [selectedDeviceID, setSelectedDeviceID] = useState(null);
	const [startDate, setStartDate] = useState(moment().format('YYYYMMDD'));
	const [endDate, setEndDate] = useState(moment().format('YYYYMMDD'));

	useEffect(() => {
		if (company.company_id) {
			getDevices();
			getTrips(selectedDeviceID, startDate, endDate);
		}
	}, [company.company_id])

	const getDevices = () => {
		toggleLoader(true);

		getDevicesList(company.company_id)
			.then(res => {
				const devices = _.get(res, 'data.response.devices', [])
				setDevices(devices);
				setInitialData(devices);
				toggleLoader(false);
			})
			.catch((error) => {
				setDevices([]);
				setInitialData([]);
				toggleLoader(false)
				console.log('!getEventDriver error: ', error.response, error)

				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription);
			})
	}

	const getTrips = (device_id, start_ts, end_ts) => {
		toggleLoader(true);
		const params = {
			companyId: company.company_id,
			start_ts: momenttz(moment(start_ts || startDate).format('YYYY-MM-DD 00:00:00')).utc().format('YYYYMMDDHHmmss'),
			end_ts: momenttz(moment(end_ts || endDate).format('YYYY-MM-DD 23:59:59')).utc().format('YYYYMMDDHHmmss'),
		}
		if (device_id) params.device_id = device_id;

		getDriverTripsPhotos(params)
			.then(res => {
				const trips = res.data.response.trips;
				setTrips(trips);
				toggleLoader(false);
			})
			.catch((error) => {
				setTrips([]);
				toggleLoader(false);
				console.log('!getEventDriver error: ', error.response, error);
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription);
			})
	}

	const onDateChanged = (start_date, end_date) => {
		const start_ts = moment(start_date).format('YYYYMMDD');
		const end_ts = moment(end_date).format('YYYYMMDD');
		setStartDate(start_ts);
		setEndDate(end_ts);
		getTrips(selectedDeviceID, start_ts, end_ts);
	};

	const displayItemName = (item) => {
		return item.vehicle_name || item.device_id
	}

	const getItemValue = (item) => {
		return item.vehicle_name || item.device_id;
	}

	const matchStateToTerm = (item, value) => {
		if (item.vehicle_name) {
			return item.vehicle_name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
		}

		return item.device_id.toString().toLowerCase().indexOf(value.toLowerCase()) !== -1;
	}

	const vehicleNameFormatter = (cell, row) => row.vehicle_name || row.device_id;

	const timestampFormatter = (cell) => {
		if (cell) {
			return moment(`${cell}+00`).format('M/DD/YYYY hh:mm:ss A');
		}
	}

	const searchVehicle = (value) => {
		const val = value.toLowerCase();
		let filter = initialData;
		if (val) {
			filter = initialData.filter(item => (
				(item.device_id && item.device_id.toString().toLowerCase().includes(val))
				|| (item.vehicle_name && item.vehicle_name.toLowerCase().includes(val))
			))
		}

		setDevices(filter);
	}

	const handleViewSnapshotClick = (e, row) => {
		e.preventDefault();
		setSelectedRow(row);
	}

	const actionsFormatter = (cell, row) => {
		return (
			<span>
				<a href="/" onClick={e => handleViewSnapshotClick(e, row)}>
					{t('linkViewSnapshot')}
				</a>
			</span>
		)
	}

	const formatCSVFileName = () => {
		const timeframe = moment(startDate).format('M-D-YY') + (startDate === endDate ? '' : '--' + moment(endDate).format('M-D-YY'))
		return `${t('csvFileName')}_${timeframe}.csv`
	}

	const closeSnapshotModal = () => {
		setSelectedRow(null);
	}

	const getPreviousEvents = () => {
		const ts = momenttz(startDate).subtract(1, 'days').format('YYYYMMDD');
		setStartDate(ts);
		setEndDate(ts);
		getTrips(selectedDeviceID, ts, ts);
	}

	const getNextEvents = () => {
		const ts = momenttz(endDate).add(1, 'days').format('YYYYMMDD');

		if (moment().format('YYYYMMDD') < ts) {
			toastr.info('', t('toastrNoFutureTrips'));
		} else {
			setStartDate(ts);
			setEndDate(ts);
			getTrips(selectedDeviceID, ts, ts);
		}
	}

	return (
		<>
			<div className='page-subheader debugSnapshots'>
				<div className='subheader-section search-flex'>
					<EventClipsDateRange
						startDate={startDate}
						endDate={endDate}
						onSelectDate={onDateChanged}
						getPreviousEvents={getPreviousEvents}
						getNextEvents={getNextEvents}
					/>
					<div className='search-bar-wrapper'>
						<Autocomplete
							autoHighlight
							value={autoValue}
							inputProps={{ id: 'states-autocomplete' }}
							wrapperProps={{ className: 'search-autocomplete unknownDriver' }}
							wrapperStyle={{ position: 'relative', zIndex: 1 }}
							getItemValue={getItemValue}
							shouldItemRender={matchStateToTerm}
							menuStyle={{
								borderRadius: '3px',
								boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
								background: 'rgba(255, 255, 255, 0.9)',
								padding: '2px 0',
								fontSize: '90%',
								position: 'absolute',
								overflow: 'auto',
								maxHeight: '200px',
								left: '2.5%',
								top: 'auto'
							}}
							onChange={(e, value) => {
								setAutoValue(value);
								searchVehicle(value);
								!value && setSelectedDeviceID('');
							}}
							onSelect={(value, item) => {
								setAutoValue(value);
								searchVehicle(value);
								setSelectedDeviceID(item.device_id);
								getTrips(item.device_id);
							}}
							renderMenu={function (items, value, style) {
								return <div className="items-list" style={{ ...style, ...this.menuStyle }} children={items} />
							}
							}
							renderItem={(item, isHighlighted) => (
								<div
									className={`item ${isHighlighted ? 'item-highlighted' : ''}`}
									key={item.device_id}
								>
									{displayItemName(item)}
								</div>
							)}
							renderInput={(props) => (
								<input {...props} placeholder={t('placeholderSearchVehicle')} className="vehicle-search" />
							)}
							items={devices}
						/>
						{searchIcon}
					</div>
				</div>
			</div>

			<main className="main-content-block unknown-drivers-trips">
				<BootstrapTable
					data={trips}
					{...tableExportOptions}
					csvFileName={formatCSVFileName()}
				>
					<TableHeaderColumn
						width="18%"
						dataField="device_id"
						isKey
						dataSort
					>
						{t('headerDeviceId')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="22%"
						dataField="vehicle_name"
						dataFormat={vehicleNameFormatter}
						dataSort
					>
						{t('headerVehicleName')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="18%"
						dataField="driver_id"
						dataSort
					>
						{t('headerDriverId')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="22%"
						dataField="driver_name"
						dataSort
					>
						{t('headerDriverName')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="20%"
						dataField="timestamp"
						dataFormat={timestampFormatter}
						dataSort
					>
						{t('headerTimestamp')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="18%"
						dataField="status"
						dataSort
					>
						{t('headerStatus')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="20%"
						dataField="snapshot_url"
						dataFormat={actionsFormatter}
						tdStyle={{ whiteSpace: 'normal' }}
					>
						{t('headerActions')}
					</TableHeaderColumn>
				</BootstrapTable>
			</main>

			{selectedRow &&
				<Modal
					show
					onHide={closeSnapshotModal}
					size='lg'
				>
					<Modal.Header closeButton>
						<Modal.Title>{t('titleSnapshot')}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="selectedSnapshot">
							<img style={{ width: '100%', height: 'auto' }} src={selectedRow?.snapshot_url} />
						</div>
					</Modal.Body>
					<Modal.Footer>
						<CustomButton variant='primary' onClick={closeSnapshotModal}>{t('btnClose')}</CustomButton>
					</Modal.Footer>
				</Modal>
			}
		</>
	);
}

const mapStateToProps = ({ user, company }) => ({
	user: user.user,
	company: company.company
});

const mapDispatchToProps = dispatch => ({
	toggleLoader: (show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show });
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(DebugSnapshots);
